import { apiUrl } from "./apiUrl";
import { isUploadOpen } from "./talentTheme";

export function isDemoUser(user) {
  return (
    user?.source === "DEMO" ||
    user?.role === "DEMO" ||
    user?.role === "demobypass"
  );
}

/**
 * @param {{ completed?: boolean, hasUpload?: boolean }} status
 * @param {object} themeData
 * @returns {"/yoga-poses"|"/yoga-upload"|"/yoga-gallery"}
 */
export function getTalentResumePath(status, themeData) {
  const completed = Boolean(status?.completed);
  const hasUpload = Boolean(status?.hasUpload);

  if (!completed) return "/yoga-poses";
  if (isUploadOpen(themeData) && !hasUpload) return "/yoga-upload";
  return "/yoga-gallery";
}

export async function fetchTalentGameStatus(adminToken, user) {
  const resp = await fetch(apiUrl("/spotGameStatus"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${adminToken}`,
    },
    body: JSON.stringify({
      userId: user.userId,
      sessionId: user.sessionId,
      organizationId: user.organizationId,
    }),
  });

  const data = await resp.json();
  if (!resp.ok || !data?.success) {
    throw new Error(data?.message || "Failed to load game status");
  }

  return data;
}
